<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Badges</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Basic Example</h5>
              <p>Badges scale to match the size of the immediate parent element by using relative font sizing and em
                units.</p>
              <div class="card mb-5 shadow-sm">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab('1')"
                      [ngClass]="{'active': viewTab}">View</a></li>
                  <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('2')"
                      [ngClass]="{'active': codeTab}">Code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="tab-view-1" [ngClass]="{'show active': viewTab}">
                      <h1>Example heading <span class="badge bg-secondary">New</span></h1>
                      <h2>Example heading <span class="badge bg-secondary">New</span></h2>
                      <h3>Example heading <span class="badge bg-secondary">New</span></h3>
                      <h4>Example heading <span class="badge bg-secondary">New</span></h4>
                      <h5>Example heading <span class="badge bg-secondary">New</span></h5>
                      <h6>Example heading <span class="badge bg-secondary">New</span></h6>
                    </div>
                    <div class="tab-pane fade" id="tab-code-1" [ngClass]="{'show active': codeTab}">
                      <pre><code class="language-html">&lt;h1&gt;Example heading &lt;span class=&quot;badge bg-secondary&quot;&gt;New&lt;/span&gt;&lt;/h1&gt;
    &lt;h2&gt;Example heading &lt;span class=&quot;badge bg-secondary&quot;&gt;New&lt;/span&gt;&lt;/h2&gt;
    &lt;h3&gt;Example heading &lt;span class=&quot;badge bg-secondary&quot;&gt;New&lt;/span&gt;&lt;/h3&gt;
    &lt;h4&gt;Example heading &lt;span class=&quot;badge bg-secondary&quot;&gt;New&lt;/span&gt;&lt;/h4&gt;
    &lt;h5&gt;Example heading &lt;span class=&quot;badge bg-secondary&quot;&gt;New&lt;/span&gt;&lt;/h5&gt;
    &lt;h6&gt;Example heading &lt;span class=&quot;badge bg-secondary&quot;&gt;New&lt;/span&gt;&lt;/h6&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <p>Badges can be used as part of links or buttons to provide a counter.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <button type="button" class="btn btn-primary">
                    Notifications <span class="badge bg-light text-dark">4</span>
                  </button>
                  <hr>
                  <pre><code class="language-html">&lt;button type=&quot;button&quot; class=&quot;btn btn-primary&quot;&gt;
        Notifications &lt;span class=&quot;badge bg-light text-dark&quot;&gt;4&lt;/span&gt;
    &lt;/button&gt;</code></pre>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Contextual variations</h5>
              <p>Add any of the below mentioned modifier classes to change the appearance of a badge.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <span class="badge bg-primary ml-1">Primary</span>
                  <span class="badge bg-secondary ml-1">Secondary</span>
                  <span class="badge bg-success ml-1">Success</span>
                  <span class="badge bg-danger ml-1">Danger</span>
                  <span class="badge bg-warning ml-1">Warning</span>
                  <span class="badge bg-info ml-1">Info</span>
                  <span class="badge bg-light text-dark ml-1">Light</span>
                  <span class="badge bg-dark ml-1">Dark</span>
                  <hr>
                  <pre><code class="language-html">&lt;span class=&quot;badge bg-primary&quot;&gt;Primary&lt;/span&gt;
    &lt;span class=&quot;badge bg-secondary&quot;&gt;Secondary&lt;/span&gt;
    &lt;span class=&quot;badge bg-success&quot;&gt;Success&lt;/span&gt;
    &lt;span class=&quot;badge bg-danger&quot;&gt;Danger&lt;/span&gt;
    &lt;span class=&quot;badge bg-warning&quot;&gt;Warning&lt;/span&gt;
    &lt;span class=&quot;badge bg-info&quot;&gt;Info&lt;/span&gt;
    &lt;span class=&quot;badge bg-light text-dark&quot;&gt;Light&lt;/span&gt;
    &lt;span class=&quot;badge bg-dark&quot;&gt;Dark&lt;/span&gt;</code></pre>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Pill badges</h5>
              <p>Use the <code class="text-center">.bg-pill</code> modifier class to make badges more rounded (with a
                larger <code class="text-center">border-radius</code> and additional horizontal <code
                  class="text-center">padding</code>). Useful if you miss the badges from v3.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <span class="badge bg-pill bg-primary">Primary</span>
                  <span class="badge bg-pill bg-secondary ml-1">Secondary</span>
                  <span class="badge bg-pill bg-success ml-1">Success</span>
                  <span class="badge bg-pill bg-danger ml-1">Danger</span>
                  <span class="badge bg-pill bg-warning ml-1">Warning</span>
                  <span class="badge bg-pill bg-info ml-1">Info</span>
                  <span class="badge bg-pill bg-light text-dark ml-1">Light</span>
                  <span class="badge bg-pill bg-dark ml-1">Dark</span>
                  <hr>
                  <pre><code class="language-html">&lt;span class=&quot;badge bg-pill bg-primary&quot;&gt;Primary&lt;/span&gt;
    &lt;span class=&quot;badge bg-pill bg-secondary&quot;&gt;Secondary&lt;/span&gt;
    &lt;span class=&quot;badge bg-pill bg-success&quot;&gt;Success&lt;/span&gt;
    &lt;span class=&quot;badge bg-pill bg-danger&quot;&gt;Danger&lt;/span&gt;
    &lt;span class=&quot;badge bg-pill bg-warning&quot;&gt;Warning&lt;/span&gt;
    &lt;span class=&quot;badge bg-pill bg-info&quot;&gt;Info&lt;/span&gt;
    &lt;span class=&quot;badge bg-pill bg-light text-dark&quot;&gt;Light&lt;/span&gt;
    &lt;span class=&quot;badge bg-pill bg-dark&quot;&gt;Dark&lt;/span&gt;</code></pre>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Links</h5>
              <p>Using the contextual <code class="text-center">.bg-*</code> classes on an <code
                  class="text-center">&lt;a&gt;</code> element quickly provide <em>actionable</em> badges with hover and
                focus states.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <a href="#" class="badge bg-primary">Primary</a>
                  <a href="#" class="badge bg-secondary ml-1">Secondary</a>
                  <a href="#" class="badge bg-success ml-1">Success</a>
                  <a href="#" class="badge bg-danger ml-1">Danger</a>
                  <a href="#" class="badge bg-warning ml-1">Warning</a>
                  <a href="#" class="badge bg-info ml-1">Info</a>
                  <a href="#" class="badge bg-light text-dark ml-1">Light</a>
                  <a href="#" class="badge bg-dark ml-1">Dark</a>
                  <hr>
                  <pre><code class="language-html">&lt;a href=&quot;#&quot; class=&quot;badge bg-primary&quot;&gt;Primary&lt;/a&gt;
    &lt;a href=&quot;#&quot; class=&quot;badge bg-secondary&quot;&gt;Secondary&lt;/a&gt;
    &lt;a href=&quot;#&quot; class=&quot;badge bg-success&quot;&gt;Success&lt;/a&gt;
    &lt;a href=&quot;#&quot; class=&quot;badge bg-danger&quot;&gt;Danger&lt;/a&gt;
    &lt;a href=&quot;#&quot; class=&quot;badge bg-warning&quot;&gt;Warning&lt;/a&gt;
    &lt;a href=&quot;#&quot; class=&quot;badge bg-info&quot;&gt;Info&lt;/a&gt;
    &lt;a href=&quot;#&quot; class=&quot;badge bg-light text-dark&quot;&gt;Light&lt;/a&gt;
    &lt;a href=&quot;#&quot; class=&quot;badge bg-dark&quot;&gt;Dark&lt;/a&gt;</code></pre>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->

</div>
